import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-rapport-activite',
  templateUrl: './rapport-activite.component.html',
  styleUrls: ['./rapport-activite.component.scss']
})
export class RapportActiviteComponent implements OnInit {
  mode_dr : any = 3;
  pdfSrc: string = "assets/file/Rapport Hebdo VA.pdf";
  constructor(private router: Router) { }

  ngOnInit() {
  }

  raportMedecin(){
    this.router.navigate(['rapport-med']);
  }
  raportRembourse(){
    this.router.navigate(['rapport-remb']);
  }
  raportAutre(){
    this.router.navigate(['rapport-autre']);
  }

}
